import { ConfirmationModal } from '@pixelcanvas/ui';

interface UnpublishMetaverseConfirmModalProps {
  name: string;
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function UnpublishMetaverseConfirmModal({
  name,
  open,
  onClose,
  onConfirm,
}: UnpublishMetaverseConfirmModalProps) {
  return (
    <ConfirmationModal
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title="UNPUBLISH YOUR METAVERSE"
      confirm="Unpublish"
    >
      <ConfirmationModal.Description>Are you sure you want to unpublish {name}?</ConfirmationModal.Description>
      <ConfirmationModal.Description>Please note that any visitor who are currently on this metaverse will be removed from the site.</ConfirmationModal.Description>
    </ConfirmationModal>
  );
}
